import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const StatusStableIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 12 12" fill="currentColor" {...props}>
      <rect width={9} height={9} x={1.5} y={1.5} rx={4.5} />
    </Icon>
  )
);
export default StatusStableIcon;
